<script>
    import { Statistic, initStatistic, Text, Icon } from "svantic";
    initStatistic();
    import { createBetWs } from "../../../../scripts/stake-api";

    import { get } from "svelte/store";
    import { ApiKey, Mirror } from "../../../../stores";

    let apikey = get(ApiKey)
    let bet = {};

    export const placeBet = async (configs) => {
       // console.log("packs placeBet ", configs)
        try {
            const req = await fetch(`https://stake.${$Mirror}/_api/casino/packs/bet`, {
                method: "POST",
                body: JSON.stringify({
                    currency: configs?.variables?.currency,
                    amount: configs?.variables?.amount,
                }),
                headers: {
                    "content-type": "application/json",
                    "x-access-token": $ApiKey,
                },
            });

            if (req.status === 200) {
                let resp = await req.json();

                let r = { data: resp?.packsBet };
                if (r.data) bet = r.data;

                return r;
            }
        } catch (e) {
            //any connection related error
            console.error("catch error fnc placeBet - e: ", e);
            return { error: e, data: null };
        } finally {
        }
    };
</script>

<Statistic size="huge" inverted>
    <Statistic.Value text={true}>
        {#key bet}
            {bet.result ? bet.result.result.toFixed(2) : ""}
            <Icon size="small" name="times"></Icon>
        {/key}
    </Statistic.Value>
    <Statistic.Label><Text class="medium">Roll</Text></Statistic.Label>
</Statistic>

<style>
</style>
